<div>
    <div class="forms-feature-header">
        <div>
            <h4>
                <b *ngIf="!currentObject">
                    <span>Nouveau Message</span>
                </b>
                <b *ngIf="currentObject">
                    <span>Modification Message</span>
                    <span class="current_values"
                        >[{{ currentObject?.reference }}]</span
                    >
                </b>
            </h4>
        </div>
        <div></div>
        <div class="forms-feature-header__button">
            <div>
                <p-button
                    label="Fermer"
                    styleClass="p-button-danger"
                    (click)="close()"
                ></p-button>
            </div>
        </div>
    </div>
    <hr />
    <!--------------------------FORMS-------------------------->
    <div *ngIf="!currentObject?.show">
        <div [formGroup]="adminForm">
            <fieldset>
                <legend>
                    <b>Sujets</b>
                </legend>
                <div>
                    <div style="display: flex; gap: 2rem">
                        <div class="trans-radio d-flex gap-3">
                            <p-radioButton
                                name="sujet"
                                formControlName="sujet"
                                [value]="sourceOffreCommercial"
                                [inputId]="sourceOffreCommercial"
                            ></p-radioButton>
                            <label
                                [for]="sourceOffreCommercial"
                                style="margin-top: 0.9rem"
                                >Offre Commerciale</label
                            >
                        </div>
                        <div class="trans-radio d-flex gap-3">
                            <p-radioButton
                                name="sujet"
                                formControlName="sujet"
                                [value]="sourceContrat"
                                [inputId]="sourceContrat"
                            ></p-radioButton>
                            <label
                                [for]="sourceContrat"
                                style="margin-top: 0.9rem"
                                >Contrat</label
                            >
                        </div>
                        <div class="trans-radio d-flex gap-3">
                            <p-radioButton
                                name="sujet"
                                formControlName="sujet"
                                [value]="sourceFacture"
                                [inputId]="sourceFacture"
                            ></p-radioButton>
                            <label
                                [for]="sourceFacture"
                                style="margin-top: 0.9rem"
                                >Facture</label
                            >
                        </div>
                    </div>
                </div>
            </fieldset>
            <fieldset>
                <legend>
                    <b>Contenu</b>
                </legend>
                <div class="row" style="padding-top: 0rem !important">
                    <div class="form-group">
                        <label>
                            <b>Objet<span class="text-danger">*</span></b>
                        </label>
                        <input type="text" formControlName="objet" pInputText />
                    </div>
                </div>
                <div class="row" style="padding-top: 0.8rem !important">
                    <div class="form-group">
                        <label>
                            <b>Message<span class="text-danger">*</span></b>
                        </label>
                        <textarea
                            rows="2"
                            formControlName="message"
                            cols="30"
                            pInputTextarea
                        ></textarea>
                    </div>
                </div>
                <div class="row" style="padding-top: 0.8rem !important">
                    <div class="form-group">
                        <label>
                            <b>Pièce jointe</b>
                        </label>
                        <input
                            type="file"
                            style="
                                padding: 0.6rem;
                                border: 1px solid;
                                border-radius: 0.3rem;
                                color: #000;
                            "
                            (change)="OnChangeFile($event.target.files)"
                            accept="image/png,image/jpeg"
                        />
                    </div>
                </div>
            </fieldset>
            <fieldset>
                <legend>
                    <b>Signature</b>
                </legend>
                <div class="row" style="padding-top: 0 !important">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>
                                <b>Nom<span class="text-danger">*</span></b>
                            </label>
                            <input
                                type="text"
                                formControlName="signature_nom"
                                pInputText
                            />
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>
                                <b
                                    >Fonction<span class="text-danger"
                                        >*</span
                                    ></b
                                >
                            </label>
                            <input
                                type="text"
                                formControlName="signature_fonction"
                                pInputText
                            />
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>
                                <b>Contact<span class="text-danger">*</span></b>
                            </label>
                            <input
                                type="text"
                                formControlName="signature_contact"
                                pInputText
                            />
                        </div>
                    </div>
                </div>
            </fieldset>
        </div>
        <div class="submit-form">
            <p-button
                label="Enregistrer"
                [label]="!currentObject ? 'Enregistrer' : 'Modifier'"
                [disabled]="!adminForm.valid"
                styleClass="p-button-success mt-2 pull-right"
                (click)="!currentObject ? handleSave() : handleUpdate()"
            ></p-button>
        </div>
    </div>
    <div *ngIf="currentObject?.show">
        <p-tabView>
            <p-tabPanel header="HISTORIQUE">
                <app-history
                    [typeModel]="'messagerie'"
                    [idModel]="currentObject.id"
                >
                </app-history>
            </p-tabPanel>
        </p-tabView>
    </div>
</div>
